<app-stack-layout>
    <h1>Logging out...</h1>
    <p class="mt-sm">We're securing your local data, please wait a few seconds.</p>

    <app-spinner class="mt-xl"></app-spinner>

    <small class="mt-xl">You will be redirected to login page once completed.</small>
</app-stack-layout>
